<div *ngIf="tabs?.length" class="as-tab-container" [class.primary]="isPrimary" [class.secondary]="!isPrimary">
  <nav [id]="id" animationDuration="0" mat-tab-nav-bar [tabPanel]="tabPanel" [class.stretch]="isPrimary"
    [backgroundColor]="isPrimary ? 'primary' : null"
    [class.mat-elevation-z1]="!ignoreShadow && !isPrimary">
    <ng-container *ngFor="let tab of tabs">
      <a mat-tab-link *ngIf="showTab(tab)" 
        [class.active]="isActiveTab(tab)" [active]="isActiveTab(tab)" [routerLink]="tab.route" [queryParams]="tab.queryParams">
        {{tab.name | translate:locale.language}}
      </a>
    </ng-container>
  </nav>
  <mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
</div>